import { useState, useEffect } from 'react';
import AmplifyTokenManager from 'utils/AmplifyTokenManager';

export interface TokenManager {
    amplifyToken: string | null;
    refreshToken: () => void;
    tokenLoading: boolean;
}

// TODO Add Retry Logic for when Token isn't acquired (haven't actually encountered the issue)
export const useAmplifyToken = (): TokenManager => {
    const [amplifyToken, setAmplifyToken] = useState<string | null>(null);
    const [tokenLoading, setTokenLoading] = useState<boolean>(true);

    const getToken = () => {
        setTokenLoading(true);
        AmplifyTokenManager.getInstance().getIdToken()
            .then((token) => 
                setAmplifyToken(token?.idToken)
            )
            .catch((err) => {
                console.error(`Failed to retrieve Amplify Token. ${err}`);
            })
            .finally(
                () => setTokenLoading(false)
             );
    };

    useEffect(() => {
        getToken();
    }, []);

    return {
        amplifyToken,
        refreshToken: getToken,
        tokenLoading,
    }
};